import { render } from "./ForgotPasswordModal.vue?vue&type=template&id=cc0c5e44&scoped=true"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=js"

import "@/assets/user-shared.css?vue&type=style&index=0&lang=css&external"
import "./ForgotPasswordModal.vue?vue&type=style&index=1&id=cc0c5e44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc0c5e44"]])

export default __exports__